<template>
  <div class="col-lg-12" style="padding: 20px">
    <div class="main-card mb-3 card" style="margin-left: 10px">
      <div class="card-body">
        <h5 class="card-title" v-if="this.$root.guiPerm == 'ENTERPRISE'">
          클래스 리스트
        </h5>
        <span v-if="this.$root.guiPerm == 'ENTERPRISE'"
          >학생들을 관리할 클래스를 등록 할 수 있습니다.</span
        >
        <h5 class="card-title" v-if="this.$route.query.type == 'LOCAL'">
          본부별 관리
          <div
            class="sub_title"
            style="
              margin-bottom: 20px;
              color: #333;
              font-size: 13px;
              border: 1px solid #ccc;
              background: #f8f8f8;
              height: 30px;
              text-align: right;
              position: absolute;
              right: 20px;
              top: 10px;
              padding: 2px 10px;
            "
          >
            기관관리 → 본부별 관리
          </div>
        </h5>
        <h5 class="card-title" v-if="this.$route.query.type == 'ENTERPRISE'">
          캠퍼스관리
          <div
            class="sub_title"
            style="
              margin-bottom: 20px;
              color: #333;
              font-size: 13px;
              border: 1px solid #ccc;
              background: #f8f8f8;
              height: 30px;
              text-align: right;
              position: absolute;
              right: 20px;
              top: 10px;
              padding: 2px 10px;
            "
          >
            기관관리 → 캠퍼스 관리
          </div>
        </h5>

        <query-grid :config="config" ref="qg">
          <template #items="props">
            <tr v-for="(record, i) in props.records" v-bind:key="record.id">
              <td scope="row">{{ record.id }}</td>
              <td style="padding: 15px 0px">A-00{{ record.id }}</td>
              <td>{{ record.agreementType }}</td>
              <td>
                <Business :biz="record.parent" />
              </td>
              <td>
                <Business :biz="record" :ref="'biz' + i" />
              </td>
              <td>{{ record.phone }}</td>
              <td>{{ record.startDate }}</td>
              <td>{{ record.endDate }}</td>
              <td>
                <button
                  v-if="record.type != 'ROOT'"
                  class="btn btn-danger btn-sm"
                  data-bs-toggle="modal"
                  data-bs-target=".deleteModal"
                  @click="checkDeleteAvailable(record)"
                >
                  삭제
                </button>
              </td>
            </tr>
          </template>
          <template #actions>
            <button
              class="btn btn-danger"
              data-bs-toggle="modal"
              data-bs-target=".bd-example-modal-lg"
              @click="creatingMode()"
              v-if="this.$root.guiPerm !== 'ENTERPRISE'"
            >
              신규등록
            </button>
            <button
              class="btn btn-danger"
              data-bs-toggle="modal"
              data-bs-target=".bd-example-modal-lg"
              @click="creatingMode()"
              v-if="this.$root.guiPerm == 'ENTERPRISE'"
            >
              클래스 등록
            </button>
          </template>
        </query-grid>

        <div
          class="modal fade bd-example-modal-lg"
          tabindex="-1"
          id="bizModal"
          role="dialog"
          aria-labelledby="myLargeModalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header">
                <h5
                  class="modal-title"
                  id="exampleModalLongTitle"
                  v-if="this.$root.guiPerm == 'ROOT'"
                >
                  관리자 등록
                </h5>
                <h5
                  class="modal-title"
                  id="exampleModalLongTitle"
                  v-if="this.$root.guiPerm == 'ENTERPRISE'"
                >
                  클래스 등록
                </h5>
              </div>
              <div class="modal-body">
                <table class="table">
                  <colgroup>
                    <col style="width: 25%" />
                    <col style="width: 25%" />
                    <col style="width: 25%" />
                    <col style="width: 25%" />
                  </colgroup>
                  <tbody>
                    <tr>
                      <td class="th_bg">관리자코드</td>
                      <td>자동생성</td>
                      <td class="th_bg">
                        <i class="fas fa-check-circle"></i>사용여부
                      </td>
                      <td>
                        <div>
                          <div>
                            <select class="hidtype" id="inputGroupSelect01">
                              <option selected>선택</option>
                              <option value="1">사용</option>
                              <option value="2">미사용</option>
                            </select>
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td class="th_bg"><i class="fas fa-check-circle"></i>생성</td>
                      <td>
                        {{ this.selData.type }}
                        <tree-btn :tree="this.$refs.bizTree" />
                      </td>
                      <td class="th_bg">생성위치</td>
                      <td>
                        <Business
                          v-for="history in selHistory"
                          :key="history.id"
                          :biz="history"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td class="th_bg">소속구분</td>
                      <td>
                        <template v-if="selBiz.type == 'ROOT'"
                          ><button class="btn btn-primary btn-sm">
                            본사
                          </button></template
                        >
                        <template v-if="selBiz.type == 'LOCAL'"
                          ><button class="btn btn-info btn-sm">
                            지사
                          </button></template
                        >
                        <template v-if="selBiz.type == 'ENTERPRISE'"
                          ><button class="btn btn-success btn-sm">
                            학원
                          </button></template
                        >
                        <template v-if="selBiz.type == 'CLASS'"
                          ><button class="btn btn-warning btn-sm">
                            클래스명
                          </button></template
                        >
                      </td>
                      <td class="th_bg">관리구분</td>
                      <td>
                        <template v-if="selBiz.type == 'ROOT'">지사</template>
                        <template v-if="selBiz.type == 'LOCAL'">학원</template>
                        <template v-if="selBiz.type == 'ENTERPRISE'"
                          >클래스</template
                        >
                      </td>
                    </tr>

                    <tr>
                      <td class="th_bg">
                        <i class="fas fa-check-circle"></i>시작일
                      </td>
                      <td>
                        <input
                          type="date"
                          class="hidtype"
                          v-model="changedData.startDate"
                        />
                      </td>
                      <td class="th_bg">
                        <i class="fas fa-check-circle"></i>종료일
                      </td>
                      <td>
                        <input
                          type="date"
                          class="hidtype"
                          v-model="changedData.endDate"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>

                <table
                  class="table"
                  v-if="selBiz.type == 'ROOT' || selBiz.type == 'LOCAL'"
                >
                  <tbody>
                    <tr>
                      <td class="th_bg">사업자등록번호</td>
                      <td>
                        <input
                          class="hidtype"
                          v-model="changedData.bizNo"
                          placeholder="000-00-00000"
                        />
                      </td>
                      <td class="th_bg" v-if="this.$root.guiPerm == 'ROOT'">
                        학원명
                      </td>
                      <td
                        class="th_bg"
                        v-if="this.$root.guiPerm == 'ENTERPRISE'"
                      >
                        클래스명
                      </td>

                      <td>
                        <input
                          class="hidtype"
                          v-model="changedData.name"
                          placeholder="홍길동"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td class="th_bg">연락처</td>
                      <td>
                        <input
                          class="hidtype"
                          v-model="changedData.contact"
                          placeholder="02-1544-7000"
                        />
                      </td>
                      <td class="th_bg">휴대폰</td>
                      <td>
                        <input
                          class="hidtype"
                          v-model="changedData.phone"
                          placeholder="010-1544-7000"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td class="th_bg">대표자명</td>
                      <td>
                        <input
                          class="hidtype"
                          v-model="changedData.headName"
                          placeholder="홍길동"
                        />
                      </td>
                      <td class="th_bg">주민번호</td>
                      <td>
                        <input
                          class="hidtype"
                          v-model="changedData.ssn"
                          placeholder="000000-0000000"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td class="th_bg">이메일</td>
                      <td>
                        <input
                          class="hidtype"
                          v-model="changedData.email"
                          placeholder="support@mypathkr.com"
                        />
                      </td>
                      <td class="th_bg">학습타입</td>
                      <td>
                        <select
                          class="hidtype"
                          v-model="changedData.study_type"
                        >
                          <option selected>선택</option>
                          <option value="PLS">PLS</option>
                          <!--option value="ALS">ALS</option-->
                        </select>
                      </td>
                    </tr>
                    <tr>
                      <td class="th_bg">주 소</td>
                      <td colspan="3">
                        <input
                          class="hidtype"
                          style="width: 80%; margin: 2px"
                          v-model="changedData.address1"
                          placeholder="주소(도로명주소까지)"
                        />
                        <br />
                        <input
                          class="hidtype"
                          style="width: 80%; margin: 2px"
                          v-model="changedData.address2"
                          placeholder="주소(호수)"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td class="th_bg">은행</td>
                      <td>
                        <select class="hidtype" v-model="changedData.bankCode">
                          <option value="001_한국은행">한국은행</option>
                          <option value="002_산업은행">산업은행</option>
                          <option value="003_기업은행">기업은행</option>
                          <option value="004_국민은행">국민은행</option>
                          <option value="007_수협중앙회">수협중앙회</option>
                          <option value="008_수출입은행">수출입은행</option>
                          <option value="011_농협은행">농협은행</option>
                          <option value="012_지역농축협">지역농축협</option>
                          <option value="020_우리은행">우리은행</option>
                          <option value="023_SC은행">SC은행</option>
                          <option value="027_한국씨티은행">한국씨티은행</option>
                          <option value="031_대구은행">대구은행</option>
                          <option value="032_부산은행">부산은행</option>
                          <option value="034_광주은행">광주은행</option>
                          <option value="035_제주은행">제주은행</option>
                          <option value="037_전북은행">전북은행</option>
                          <option value="039_경남은행">경남은행</option>
                          <option value="045_새마을금고중앙회">
                            새마을금고중앙회
                          </option>
                          <option value="048_신협중앙회">신협중앙회</option>
                          <option value="050_상호저축은행">상호저축은행</option>
                          <option value="071_우체국">우체국</option>
                          <option value="081_하나은행">하나은행</option>
                          <option value="080_하나은행 (080)">
                            하나은행 (080)
                          </option>
                          <option value="082_하나은행 (082)">
                            하나은행 (082)
                          </option>
                          <option value="088_신한은행">신한은행</option>
                          <option value="089_K뱅크">K뱅크</option>
                          <option value="090_카카오뱅크">카카오뱅크</option>
                          <option value="209_유안타증권">유안타증권</option>
                          <option value="218_현대증권">현대증권</option>
                          <option value="230_미래에셋증권">미래에셋증권</option>
                          <option value="238_대우증권">대우증권</option>
                          <option value="240_삼성증권">삼성증권</option>
                          <option value="243_한국투자증권">한국투자증권</option>
                          <option value="247_우리투자증권">우리투자증권</option>
                          <option value="261_교보증권">교보증권</option>
                          <option value="262_하이투자증권">하이투자증권</option>
                          <option value="263_HMC투자증권">HMC투자증권</option>
                          <option value="264_키움증권">키움증권</option>
                          <option value="265_이베스트투자증권">
                            이베스트투자증권
                          </option>
                          <option value="266_SK증권">SK증권</option>
                          <option value="267_대신증권">대신증권</option>
                          <option value="268_아이엠투자증권">
                            아이엠투자증권
                          </option>
                          <option value="269_한화투자증권">한화투자증권</option>
                          <option value="270_하나대투자증권">
                            하나대투자증권
                          </option>
                          <option value="278_신한금융투자">신한금융투자</option>
                          <option value="279_동부증권">동부증권</option>
                          <option value="280_유진투자증권">유진투자증권</option>
                          <option value="288_카카오페이증권">
                            카카오페이증권
                          </option>
                          <option value="287_메리츠종합금융증권">
                            메리츠종합금융증권
                          </option>
                          <option value="290_부국증권">부국증권</option>
                          <option value="291_신영증권">신영증권</option>
                          <option value="292_LIG투자증권">LIG투자증권</option>
                          <option value="092_토스뱅크">토스뱅크</option>
                          <option value="271_토스증권">토스증권</option>
                        </select>
                      </td>
                      <td class="th_bg">예금주</td>
                      <td>
                        <input
                          class="hidtype"
                          v-model="changedData.bankName"
                          placeholder="홍길동"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td class="th_bg">계좌번호</td>
                      <td colspan="3">
                        <input
                          class="hidtype"
                          v-model="changedData.bankNum"
                          placeholder="270-16-575402"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td class="th_bg">미국ID</td>
                      <td>
                        <input
                          class="hidtype"
                          v-model="changedData.ag_USID"
                          placeholder="미국 아이디"
                        />
                      </td>
                      <td class="th_bg">미국PW</td>
                      <td>
                        <input
                          class="hidtype"
                          v-model="changedData.ag_USPW"
                          placeholder="미국 비밀번호"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
                <table class="table" v-if="selBiz.type == 'LOCAL'">
                  <tbody>
                    <tr>
                      <td class="th_bg">표시 상품 Group</td>
                      <td>
                        <input
                          class="hidtype"
                          v-model="changedData.agreementType"
                          placeholder="Group 입력"
                        />
                      </td>
                      <td class="th_bg" rowspan="1">설정</td>
                      <td></td>
                    </tr>
                    <!--tr>
                      <td class="th_bg">초도물품</td>
                      <td>
                        <select name="inputGroupSelect" class="" id="inputGroupSelect">
                          <option selected>ALL</option>
                        </select><input type="date" />
                      </td>

                      <td>
                        <label>
                          <input type="radio" name="RadioGroup1" value="보카조아" id="RadioGroup1_1">
                          보카조아[종료:22-01-20]</label></td>
                    </tr>
                    <tr>
                      <td class="th_bg">상품적용<button class="btn btn-danger btn-sm" data-toggle="modal"
                          data-target="#exampleModal">추가</button>

                        <-- Modal
                        <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog"
                          aria-labelledby="exampleModalLabel" aria-hidden="true">
                          <div class="modal-dialog" role="document">
                            <div class="modal-content">
                              <div class="modal-header">
                                <h5 class="modal-title" id="exampleModalLabel">Modal title</h5>

                              </div>
                              <div class="modal-body">
                                <p class="mb-0">Lorem Ipsum has been the industry's standard dummy text ever since the
                                  1500s, when an unknown printer took a galley of type and scrambled.</p>
                              </div>
                              <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                                <button type="button" class="btn btn-primary">Save changes</button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </td>
                      <td colspan="3"> p123,p124 </td>
                    </tr-->
                  </tbody>
                </table>

                <table class="table" v-if="selBiz.type == 'ENTERPRISE'">
                  <tbody>
                    <tr>
                      <td class="th_bg">
                        <i class="fas fa-check-circle"></i>클래스명
                      </td>
                      <td>
                        <input
                          class="hidtype"
                          v-model="changedData.name"
                          placeholder="홍길동"
                        />
                      </td>
                      <td class="th_bg">
                        <i class="fas fa-check-circle"></i>클래스명(영문)
                      </td>
                      <td>
                        <input
                          class="hidtype"
                          v-model="changedData.engName"
                          placeholder="홍길동"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td class="th_bg">연락처</td>
                      <td>
                        <input
                          class="hidtype"
                          v-model="changedData.tel"
                          placeholder="02-1544-7000"
                        />
                      </td>
                      <td class="th_bg">대표강사명</td>
                      <td>
                        <input
                          class="hidtype"
                          v-model="changedData.headName"
                          placeholder="홍길동"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td class="th_bg">미국ID</td>
                      <td>
                        <input
                          class="hidtype"
                          v-model="changedData.ag_USID"
                          placeholder="미국 아이디"
                        />
                      </td>
                      <td class="th_bg">미국PW</td>
                      <td>
                        <input
                          class="hidtype"
                          v-model="changedData.ag_USPW"
                          placeholder="미국 비밀번호"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="modal-footer flex_center">
                <button type="button" class="btn btn-primary" @click="doSend()">
                  등록
                </button>
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  닫기
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div
    class="modal fade deleteModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myLargeModalLabel"
    aria-hidden="true"
    style="background: rgba(0, 0, 0, 0.8)"
  >
    <div class="modal-dialog modal-sms modal-fullscreen">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">
            기관 삭제 유효성 검사
          </h5>
        </div>
        <div class="modal-body">
          <table class="table">
            <thead>
              <tr scope="row">
                <td>타입</td>
                <td>메시지</td>
                <td>데이터</td>
              </tr>
            </thead>
            <tbody>
              <template v-for="(error, i) in deletingErrors" :key="i">
                <tr v-if="error.level != 'WARNING' || showWarn">
                  <td>
                    <template v-if="error.level == 'WARNING'"
                      ><i class="bi bi-exclamation-triangle-fill"></i
                    ></template>
                    <template v-if="error.level == 'ERROR'"
                      ><i class="bi bi-x-circle-fill"></i
                    ></template>
                    <template v-if="error.level == 'SUCCESS'"
                      ><i class="bi bi-check"></i
                    ></template>
                  </td>
                  <td>{{ error.error }}</td>
                  <td>{{ error.data_name }}</td>
                </tr>
              </template>
            </tbody>
          </table>
          오류 {{ errCnt }}개, 경고 {{ warnCnt }}개 (<input
            type="checkbox"
            v-model="showWarn"
          />경고 보기)
          <div class="flex_center">
            <button class="btn btn-info" data-bs-dismiss="modal">취소</button>
            <button
              class="btn btn-danger"
              data-bs-dismiss="modal"
              :disabled="!deletingPermitted"
              @click="commitDelete(selData)"
            >
              삭제
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <Tree
    :key="$route.path"
    :tree-data="this.$root.businesses"
    :selectable="creating ? ['ROOT', 'LOCAL'] : [selBiz.type]"
    :callback="selectedBiz"
    ref="bizTree"
  />
</template>

<style></style>

<script>
// @ is an alias to /src

import Tree from "../components/Tree";
import Business from "../components/Business";
import treeBtn from "../components/treeBtn";
import QueryGrid from "../components/QueryGrid";

import axios from "axios";
export default {
  name: "Home",
  components: {
    Tree,
    Business,
    treeBtn,
    QueryGrid,
  },
  mounted() {
    if (this.$route.query.type) {
      this.$refs.qg.pushSetting("filter_type_ENTERPRISE", false);
      this.$refs.qg.pushSetting("filter_type_LOCAL", false);
      this.$refs.qg.pushSetting("filter_type_CLASS", false);
      this.$refs.qg.pushSetting("filter_type_" + this.$route.query.type, true);

      if (this.$route.query.type != "ENTERPRISE") {
        console.log("do compare");

        this.config.search_fields.filter(function (el) {
          return el.id == "agreement_type";
        })[0].hide = true;
      } else {
        this.config.search_fields.filter(function (el) {
          return el.id == "agreement_type";
        })[0].hide = false;
      }
    } else if (this.$root.guiPerm == "ENTERPRISE") {
      this.$refs.qg.pushSetting("filter_type_ENTERPRISE", true);
      this.$refs.qg.pushSetting("filter_type_LOCAL", false);
      this.$refs.qg.pushSetting("filter_type_CLASS", false);
    } else {
      this.$refs.qg.pushSetting("filter_type_ENTERPRISE", true);
      this.$refs.qg.pushSetting("filter_type_LOCAL", true);
      this.$refs.qg.pushSetting("filter_type_CLASS", false);
    }
    if (this.$root.guiPerm == "ROOT") {
      this.config.search_fields.push({
        id: "search_del",
        name: "삭제여부",
        type: "switch",
        filter_type: {
          false: "정상",
          true: "삭제",
        },
      });
    } else if (this.$root.guiPerm == "ENTERPRISE") {
      this.config.search_fields.splice(2, 1);
    }

    this.$refs.qg.search();

    this.$watch(
      () => this.$route.query,
      function (toQuery, previousQuery) {
        // react to route changes...
        this.$refs.qg.pushSetting("filter_type_ENTERPRISE", false);
        this.$refs.qg.pushSetting("filter_type_LOCAL", false);
        this.$refs.qg.pushSetting("filter_type_refs.CLASS", false);
        if (toQuery.type)
          this.$refs.qg.pushSetting("filter_type_" + toQuery.type, true);
        if (toQuery.type && toQuery.type != "ENTERPRISE") {
          this.config.search_fields.filter(function (el) {
            return el.id == "agreement_type";
          })[0].hide = true;
        } else {
          this.config.search_fields.filter(function (el) {
            return el.id == "agreement_type";
          })[0].hide = false;
        }
        this.$refs.qg.search();
      }
    );
  },
  methods: {
    commitDelete(record) {
      axios.delete("/businesses/" + record.id).then((response) => {
        if (response.data.error) {
          $.notify(
            {
              // options
              message: "삭제 실패하였습니다. " + response.data.error,
            },
            {
              // settings
              type: "danger",
              z_index: 9999,
            }
          );
        } else {
          $.notify(
            {
              // options
              message: "삭제 성공하였습니다. ",
            },
            {
              // settings
              type: "success",
              z_index: 9999,
            }
          );
          this.search();
        }
      });
    },
    checkDeleteAvailable(record) {
      this.selData = record;
      this.showDeleteWarns = false;
      this.deletingErrors = [
        {
          level: "ERROR",
          error: "삭제 가능 여부를 조회 중입니다. 잠시만 기다려 주세요.",
          error_code: "FETCHING_DELETE",
          type: "LOADING",
          data_id: "",
          data_name: "시스템",
        },
        {
          level: "ERROR",
          error: "일관성 검사 절차가 들어있어 최장 10초 소요될 수 있습니다.",
          error_code: "FETCHING_DELETE",
          type: "LOADING",
          data_id: "",
          data_name: "시스템",
        },
      ];
      this.deletingPermitted = false;
      axios
        .get("/businesses/" + record.id + "/preCheckBeforeDelete")
        .then((response) => {
          if (response.data.error) {
            $.notify(
              {
                // options
                message: "데이터를 조회할 수 없습니다. " + response.data.error,
              },
              {
                // settings
                type: "danger",
                z_index: 9999,
              }
            );
          } else {
            //에러와 오류로 분리
            this.errCnt = 0;
            this.warnCnt = 0;
            this.deletingErrors = response.data.errors;
            if (response.data.errors.length) {
              response.data.errors.forEach((element) => {
                if (element.level == "ERROR") {
                  this.errCnt++;
                } else {
                  this.warnCnt++;
                }
              });
            }

            if (this.errCnt) {
              this.deletingErrors.push({
                level: "ERROR",
                error: "1개 이상의 오류로 기관을 삭제할 수 없습니다.",
                error_code: "ERROR",
                type: "LOADING",
                data_id: "",
                data_name: "시스템",
              });
              this.deletingPermitted = false;
            } else {
              this.deletingErrors.push({
                level: "SUCCESS",
                error: "기관을 삭제할 수 있습니다.",
                error_code: "SUCCESS",
                type: "LOADING",
                data_id: "",
                data_name: "시스템",
              });
              this.deletingPermitted = true;
            }
          }
        });
    },
    downloadErrorsCSV() {},
    doChange(name, value) {
      if (this.selData[name] === value) {
        delete this.changedData[name];
      } else {
        this.changedData[name] = value;
      }
    },
    selectedBiz(biz, history) {
      this.selBiz = biz;
      this.selHistory = history;
      if (biz.type == "LOCAL") {
        this.changedData.type = "ENTERPRISE";
      }
      if (biz.type == "ENTERPRISE") {
        this.changedData.type = "CLASS";
      }
      if (biz.type == "ROOT") {
        this.changedData.type = "LOCAL";
      }
    },
    doSend() {
      // 업데이트일 경우 patch /businesses/번호
      // 신규일 경우 post /businesses 후 post /admins 후 post /admins/번호/grants
      var data = {
        ...this.selData,
        ...this.changedData,
        parent_id: this.selBiz.id,
      };
      var send = axios({
        method: "post",
        url: "/businesses",
        data: data,
      });
      send.then((response) => {
        if (response.data.error) {
          $.notify(
            {
              // options
              message: "처리할 수 없습니다. " + response.data.error,
            },
            {
              // settings
              type: "danger",
              z_index: 9999,
            }
          );
        } else {
          this.$root.getBusinesses();
          bootstrap.Modal.getInstance(
            document.getElementById("bizModal")
          ).hide();
          $.notify(
            {
              // options
              message: "처리되었습니다.",
            },
            {
              // settings
              type: "success",
              z_index: 9999,
            }
          );

          this.$refs.qg.search();
        }
      });
    },
    creatingMode() {
      this.selData = {
        id: "",
        parent_id: "",
        name: "",
        createdAt: "",
        endDate: "",
        startDate: "",
        contact: "",
        suspended: "",
        type: "",
        bizcode: "",
        address1: "",
        address2: "",
        tel: "",
        fax: "",
        headName: "",
        intro: "",
        bizNo: "",
        bankCode: "",
        bankName: "",
        bankNum: "",
        agreementType: "",
        agreementPrice: "",
        agreementDate: "",
        local: "",
        engName: "",
        ag_USID: "",
        ag_USPW: "",
        createAdmin: true,
        ssn: "",
        phone: "",
        email: "",
        study_type: "",
      };
      this.changedData = {};
      this.selBiz = {};
      this.creating = true;
      this.$refs.bizTree.reset("");
    },
  },
  data() {
    return {
      config: {
        name: "기관리스트",
        req_endpoint: "/businesses/list",
        default_limit: 20,
        search_fields: [
          {
            id: "businesses",
            name: "소속선택",
            type: "business", // business, date, datetime,
          },
          {
            id: "filter_type",
            name: "유형",
            type: "switch",
            filter_type: {
              LOCAL: "본부",
              ENTERPRISE: "학원",
              CLASS: "클래스",
            },
          },
          {
            id: "agreement_type",
            name: "상품유형",
            type: "switch",
            filter_type: {
              A: "A(30,000원)",
              B: "B(35,000원)",
              C: "C(40,000원)",
              D: "D(40,000원)/교동",
              E: "E(30,000원)/북클럽별도",
              G: "G(42,000원)/신대",
            },
          },
          {
            id: "status",
            name: "상태",
            type: "switch",
            filter_type: {
              true: "사용",
              false: "미사용",
            },
          },
          {
            id: "search",
            name: "키워드검색",
            type: "text",
            placeholder: "본부/학원/클래스/주소로 검색",
          },
          {
            id: "date",
            name: "날짜검색",
            type: "date",
            filter_type: {
              created_at: "생성일",
              start_date: "서비스 시작일",
              end_date: "서비스 종료일",
            },
          },
        ],
        columns: [
          {
            id: "id",
            sortable: true,
            name: "번호",
            excel_print: (v) => {
              return v.id;
            },
          },
          {
            id: "code",
            name: "코드",
          },
          {
            id: "agreementType",
            name: "상품그룹",
            excel_print: (v) => {
              return v.agreementType;
            },
          },
          {
            id: "parent",
            name: "상위기관",
            excel_print: (v) => {
              return v.parent.name;
            },
          },
          {
            id: "name",
            sortable: true,
            name: "지사/학원명",
            excel_print: (v) => {
              return v.name;
            },
          },
          {
              "id": "tel",
              "name": "학원연락처",
              "not_view": true,
              "excel_print": v=>{return v.tel}
          },
          {
            id: "phone",
            name: "휴대폰번호",
            excel_print: (v) => {
              return v.phone || "";
            },
          },
          {
            id: "start_date",
            sortable: true,
            name: "시작일",
            excel_print: (v) => {
              return v.startDate || "";
            },
          },
          {
            id: "end_date",
            sortable: true,
            name: "종료일",
            excel_print: (v) => {
              return v.endDate || "";
            },
          },
          {
            id: "status",
            name: "상태",
          },
        ],
        disable_init_search: true,
      },
      records: [],
      selBiz: {
        name: "",
      },
      searchBiz: [],
      selHistory: [],
      searchKeyword: "",
      creating: true,
      selData: {
        id: "",
        parent_id: "",
        name: "",
        createdAt: "",
        endDate: "",
        startDate: "",
        contact: "",
        suspended: "",
        type: "",
        bizcode: "",
        address1: "",
        address2: "",
        tel: "",
        fax: "",
        headName: "",
        intro: "",
        bizNo: "",
        bankCode: "",
        bankName: "",
        bankNum: "",
        agreementType: "",
        agreementPrice: "",
        agreementDate: "",
        local: "",
        engName: "",
        ag_USID: "",
        ag_USPW: "",
        ssn: "",
        phone: "",
        email: "",
        study_type: "",
      },
      changedData: {},
      showDeleteWarns: false,
      deletingErrors: null,
      deletingPermitted: false,
      errCnt: 0,
      warnCnt: 0,
      showWarn: false,
    };
  },
};
</script>
